import {useFormik} from 'formik';
import {useState} from 'react';
import {CreateProjectDocumentDTO, useProjectDocuments} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddProjectDocumentFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddProjectDocumentForm = ({setOpen}: UseAddProjectDocumentFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createProjectDocumentMutation} = useProjectDocuments();

  const onSubmit = async (values: any) => {
    setErrorMessage(null);
    try {
      const formattedValues: CreateProjectDocumentDTO = {
        title: values.title,
        priority: values.priority,
        fileUploadId: values.fileUploadId,
        fileExtension: values.fileExtension,
      };

      await createProjectDocumentMutation.mutateAsync(formattedValues);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании документа');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      priority: 1,
      fileUploadId: '',
      fileExtension: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Название не должно превышать 256 символов').required('Название обязательно'),
      priority: Yup.number().min(1, 'Приоритет должен быть минимум 1').required('Приоритет обязателен'),
      fileUploadId: Yup.string().required('Файл обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createProjectDocumentMutation.isPending,
    submitError: createProjectDocumentMutation.error
      ? (createProjectDocumentMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};

